import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '@shared/services/toast.service';

@Component({
  selector: 'app-toast-host',
  template: `
    <div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none">
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="pointer-events-auto flex items-start gap-3 min-w-72 max-w-sm px-4 py-3 rounded-lg shadow-lg bg-white border-l-4 animate-in slide-in-from-right"
          [class.border-green-500]="toast.type === 'success'"
          [class.border-red-500]="toast.type === 'error'"
          [class.border-blue-500]="toast.type === 'info'"
        >
          <p class="flex-1 text-sm text-gray-800">{{ toast.message }}</p>
          <button
            (click)="toastService.dismiss(toast.id)"
            class="text-gray-400 hover:text-gray-600 text-lg leading-none"
            aria-label="Dismiss"
          >&times;</button>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHostComponent {
  protected readonly toastService = inject(ToastService);
}
